import { useEffect, useState } from 'react';
import { getMediaDisplaySrc } from '../helper/graphic2';

export function getListingMediaSrc(mediaPath) {
  return getMediaDisplaySrc(mediaPath);
}

function getContentLabel(postType) {
  const type = String(postType || '').toLowerCase();
  if (type === 'events') return 'Event';
  if (type.includes('podcast')) return 'Podcast';
  if (type === 'news') return 'News';
  if (type.includes('blog')) return 'Blog';
  return 'Article';
}

function ImageUnavailableIcon({ className = 'h-10 w-10' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="3"
        y="5"
        width="18"
        height="14"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7 15l3.5-3.5a1.5 1.5 0 0 1 2.12 0L17 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8.5" cy="9.5" r="1.25" fill="currentColor" />
      <path
        d="M4 4l16 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ListingCardImage({
  mediaPath,
  title,
  postType,
  containerClassName = 'w-full aspect-[300/200] rounded-2xl',
  imageClassName = 'w-full aspect-[300/200] rounded-2xl object-cover transition-transform duration-300 ease-out group-hover:scale-105',
  alt = '',
  fallbackTitleClassName = 'line-clamp-3 text-lg font-medium leading-snug text-[#021744]',
  fallbackText = 'Image not available',
  showFallbackLabel = true,
  showFallbackTitle = false,
  showFallbackMessage = true,
  iconClassName = 'h-10 w-10 text-[#0099B0]/70',
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const src = getListingMediaSrc(mediaPath);
  const showFallback = !src || imageFailed;
  const contentLabel = getContentLabel(postType);

  useEffect(() => {
    setImageFailed(false);
  }, [mediaPath]);

  if (showFallback) {
    return (
      <div
        className={`${containerClassName} flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-[#E8F7F5] to-[#D4EEF0] px-5 py-6 text-center transition-transform duration-300 ease-out group-hover:scale-[1.02]`}
        role="img"
        aria-label={
          title
            ? `${contentLabel}: ${title}. ${fallbackText}.`
            : `${contentLabel}. ${fallbackText}.`
        }
      >
        <ImageUnavailableIcon className={iconClassName} />
        {showFallbackLabel && (
          <span className="text-xs font-semibold uppercase tracking-wider text-[#0099B0]">
            {contentLabel}
          </span>
        )}
        {showFallbackMessage ? (
          <p className="text-sm font-medium text-[#5a7a8a]">{fallbackText}</p>
        ) : null}
        {showFallbackTitle && title?.trim() ? (
          <p className={fallbackTitleClassName}>{title.trim()}</p>
        ) : null}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || title || ''}
      className={imageClassName}
      crossOrigin="anonymous"
      onError={() => setImageFailed(true)}
    />
  );
}
